import { NavLink } from 'react-router-dom';
import { pages } from '../data/pages';
import { useTheme } from './ThemeProvider';

export function SiteNav({ current }) {
  const { toggle } = useTheme();

  const onPrint = () => window.print();

  const linkClass = ({ isActive }) =>
    [
      'text-ink-muted hover:text-accent transition-colors',
      isActive || current === undefined ? '' : '',
    ].join(' ');

  const activeStyle = ({ isActive }) =>
    isActive ? { color: 'var(--accent)' } : undefined;

  return (
    <nav
      aria-label="Site"
      className="no-print sticky top-0 z-50 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 bg-paper px-6 py-2.5 border-b border-rule font-mono text-[10px] uppercase tracking-[0.2em]"
    >
      <NavLink to="/" className="text-accent font-semibold no-underline">
        ‹ Field Notes
      </NavLink>

      <ul className="flex flex-wrap gap-x-4 gap-y-1 list-none m-0 p-0">
        {pages.map((p) => (
          <li key={p.slug}>
            <NavLink
              to={`/${p.slug}`}
              title={p.title}
              className={linkClass}
              style={activeStyle}
            >
              {p.tag}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="flex gap-1.5">
        <button
          onClick={toggle}
          aria-label="Toggle theme"
          title="Toggle light/dark"
          className="font-mono text-inherit border border-ink-muted text-ink-muted bg-transparent px-2 py-[3px] cursor-pointer hover:text-accent hover:border-accent transition-colors"
        >
          ◐
        </button>
        <button
          onClick={onPrint}
          aria-label="Print"
          title="Print this page"
          className="font-mono text-inherit border border-ink-muted text-ink-muted bg-transparent px-2 py-[3px] cursor-pointer hover:text-accent hover:border-accent transition-colors"
        >
          ⎙
        </button>
      </div>
    </nav>
  );
}
